import React, {Component} from "react";
import {connect} from "react-redux";
import {Navigate} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import { googleLogout } from '@react-oauth/google';
class Logout extends Component {
  componentDidMount() {
    localStorage.removeItem('hasSeenOnboarding');
    this.props.logout();
    googleLogout();
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Navigate to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
